const listaDeDesignacao = (state) => {
    return state.items;
}

const loadingDesignacao = (state) => {
    return state.carregando
}

const paginacao = (state) => state.paginacao || null

export {
    listaDeDesignacao,
    loadingDesignacao,
    paginacao
}
